module.exports = __webpack_public_path__ + "static/media/banner-carrefour-mobile.7f79bcdc.webp";